export const angiemphraxisList = [
  {
    Label: "Cervical ICA",
    Value: "CervicalICA",
    Radio: [
      {
        Name: "Cervical ICA",
        Label: "R",
        Value: "1",
      },
      {
        Name: "Cervical ICA",
        Label: "L",
        Value: "2",
      },
    ],
  },
  {
    Label: "Carotid terminius",
    Value: "Carotidterminius",
    Radio: [
      {
        Name: "Carotid terminius",
        Label: "R",
        Value: "1",
      },
      {
        Name: "Carotid terminius",
        Label: "L",
        Value: "2",
      },
    ],
  },
  {
    Label: "M1",
    Value: "M1",
    Radio: [
      {
        Name: "M1",
        Label: "R",
        Value: "1",
      },
      {
        Name: "M1",
        Label: "L",
        Value: "2",
      },
    ],
  },
  {
    Label: "M2",
    Value: "M2",
    Radio: [
      {
        Name: "M2",
        Label: "R",
        Value: "1",
      },
      {
        Name: "M2",
        Label: "L",
        Value: "2",
      },
    ],
  },
  {
    Label: "M3",
    Value: "M3",
    Radio: [
      {
        Name: "M3",
        Label: "R",
        Value: "1",
      },
      {
        Name: "M3",
        Label: "L",
        Value: "2",
      },
    ],
  },
  {
    Label: "BA",
    Value: "BA",
    Radio: [
      {
        Name: "BA",
        Label: "A",
        Value: "1",
      },
    ],
  },
  {
    Label: "PCA",
    Value: "PCA",
    Radio: [
      {
        Name: "PCA",
        Label: "R",
        Value: "1",
      },
      {
        Name: "PCA",
        Label: "L",
        Value: "2",
      },
    ],
  },
  {
    Label: "ACA",
    Value: "ACA",
    Radio: [
      {
        Name: "ACA",
        Label: "R",
        Value: "1",
      },
      {
        Name: "ACA",
        Label: "L",
        Value: "2",
      },
    ],
  },
  {
    Label: "VA",
    Value: "VA",
    Radio: [
      {
        Name: "VA",
        Label: "R",
        Value: "1",
      },
      {
        Name: "VA",
        Label: "L",
        Value: "2",
      },
    ],
  },
];
